import Banner from "elements/Banner";
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import { clsx, styx } from "modules/Utils";
import { CSSProperties } from "react";
import emptyContent from 'assets/v2/images/emptyContent.svg';
import ButtonSymphony from "elements/ButtonSymphony";
import useScreen from "Hooks/useScreen";

interface WebsiteBuilderEmptyStateProps {
    className: string;
    style?: CSSProperties;
    title?: string;
    subtitle?: string;
    description?: string;
    children?: React.ReactNode;
    isHorizontal?: boolean;
    isImage?: boolean;
    buttonText?: string;
    onClickButton?: () => void;
}

const WebsiteBuilderEmptyState = ({
    className,
    style,
    title,
    subtitle,
    description,
    children,
    isHorizontal = false,
    isImage = true,
    buttonText,
    onClickButton,
}: WebsiteBuilderEmptyStateProps) => {
    const { mobileView } = useScreen();

    return (
        <Banner
            className={clsx('websiteBuilderEmptyStateComponent', className)}
            style={styx(
                sty.websiteBuilderEmptyStateComponent,
                isHorizontal && !mobileView && sty.websiteBuilderEmptyStateComponent_horizontal,
                style,
            )}
        >
            {isImage &&
                <img
                    className="websiteBuilderBannerImage"
                    src={emptyContent}
                    alt="emptyContent"
                    style={{
                        width: 40,
                        height: 40,
                    }}
                />
            }
            <div
                className="websiteBuilderBannerContent"
                style={styx(
                    sty.websiteBuilderBannerContent,
                    isHorizontal && !mobileView ?
                        {
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                            gap: 0,
                        }
                        :
                        {
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 8,
                        }
                )}
            >
                {title &&
                    <div
                        className="websiteBuilderBannerContentTitle"
                        style={styx(
                            isHorizontal ? Sty.text16 : Sty.text20,
                            { textAlign: 'center' }
                        )}
                    >
                        {title}
                    </div>
                }
                {subtitle &&
                    <div
                        className="websiteBuilderBannerContentSubtitle"
                        style={styx(
                            isHorizontal ? Sty.text16grey : Sty.text14grey,
                            { textAlign: 'center' }
                        )}
                    >
                        {subtitle}
                    </div>
                }
                {description &&
                    <>
                        {!isHorizontal &&
                            <div style={{ height: 1, width: 50, backgroundColor: Colors.purple }} />
                        }
                        <div
                            className="websiteBuilderBannerContentDescription"
                            style={styx(
                                Sty.text16grey,
                                { textAlign: 'center' }
                            )}
                        >
                            {description}
                        </div>
                    </>
                }
            </div>
            {buttonText && onClickButton &&
                <ButtonSymphony
                    className="websiteBuilderBannerButton"
                    style={{
                        marginLeft: mobileView ? 0 : 'auto',
                    }}
                    variant="outlined"
                    onClick={onClickButton}
                >
                    {buttonText}
                </ButtonSymphony>
            }
            {children}
        </Banner>
    )
}

const sty: Record<string, CSSProperties> = {
    websiteBuilderEmptyStateComponent: {
        border: `1px dashed ${Colors.purple}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        paddingTop: 24,
        paddingBottom: 24,
    },
    websiteBuilderEmptyStateComponent_horizontal: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 8,
    },
    websiteBuilderBannerContent: {
        display: 'flex',
        flexDirection: 'column',
    },
}

export default WebsiteBuilderEmptyState;